module.exports = __webpack_public_path__ + "static/img/game-logo-playgo.9b9d558.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-playgo.png
// module id = ELmF
// module chunks = 0 1 2 3 4 5 6